import React from "react";
import {
  BellAlertIcon,
  ComputerDesktopIcon,
  CreditCardIcon,
  GiftIcon,
  UserIcon,
} from "@heroicons/react/24/outline";
import profile from "../../assets/uicon.png";
import phone from "../../assets/phone.png";
import { BugAntIcon } from "@heroicons/react/24/solid";
import { Link } from "react-router-dom";
import '../../css/homepage.css'

const Sidebar = ({name, image}) => {
  return (
    <div className="block  px-2  overflow-hidden col-span-2 sticky bg-gradient-to-l from-[#060409] to-[#361e42] top-0 bottom-0 h-[100vh] lg:px-8 py-6 space-y-16">
      <div className="py-4">
        <div>
          <Link to="/dashboard/admin">
            <div className="flex space-x-3 my-8 bg-[#434242] items-center text-sm shadow-inner py-2 px-1 rounded-sm">
              {image ? (
                <>
                  <img
                    src={image}
                    alt="profile"
                    className="w-11 h-11 rounded-full mx-auto lg:mx-0"
                  />
                </>
              ) : (
                <img
                  src={profile}
                  alt="profile"
                  className="w-11 h-11 mx-auto lg:mx-0"
                />
              )}
              <div className="text-white space-y-1 hidden lg:block">
                <p className="text-xs font-semibold">PAYTRON</p>
                <p className="text-xs">{name}</p>
              </div>
            </div>
          </Link>
        </div>

        <div className="py-6">
          <div className="space-y-4">
            <div>
              <Link to="/dashboard/">
                <div className="flex space-x-2 bg-[#434242] text-white items-center font-semibold py-2 lg:px-4 text-[13px] rounded-md cursor-pointer hover:translate-x-2 ease-in-out delay-100">
                  <ComputerDesktopIcon className="w-6 h-6 mx-auto lg:mx-0" />
                  <p className="hidden lg:flex">Dashboard</p>
                </div>
              </Link>
            </div>

            <div>
              <Link to="/dashboard/employeemanagement">
                <div className="flex space-x-2 items-center bg-[#434242] text-white  font-semibold py-2 px-4 text-[13px] rounded-md cursor-pointer hover:translate-x-2 ease-in-out delay-100">
                  <UserIcon className="w-6 h-6 mx-auto lg:mx-0" />
                  <p className="hidden lg:flex">Employee Management</p>
                </div>
              </Link>
            </div>
            <div>
              <Link to="/dashboard/addEmployee">
                <div className="flex space-x-2 items-center bg-[#434242] text-white  font-semibold py-2 px-4 text-[13px] rounded-md cursor-pointer hover:translate-x-2 ease-in-out delay-100">
                  <BellAlertIcon className="w-6 h-6 mx-auto lg:mx-0" />
                  <p className="hidden lg:flex">Notifications</p>
                </div>
              </Link>
            </div>
            <div>
              <Link to="/dashboard/payments">
                <div className="flex space-x-2 items-center bg-[#434242] text-white  font-semibold py-2 px-4 text-[13px] rounded-md cursor-pointer hover:translate-x-2 ease-in-out delay-100">
                  <GiftIcon className="w-6 h-6 mx-auto lg:mx-0" />
                  <p className="hidden lg:flex">Send Payments</p>
                </div>
              </Link>
            </div>
            <div>
              <Link to="/dashboard/report">
                <div className="flex space-x-2 items-center bg-[#434242] text-white  font-semibold py-2 px-4 text-[13px] rounded-md cursor-pointer hover:translate-x-2 ease-in-out delay-100">
                  <BugAntIcon className="w-6 h-6 mx-auto lg:mx-0" />
                  <p className="hidden lg:flex">Report</p>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="hidden lg:flex items-center align-bottom justify-center">
          <img src={phone} alt="phone" className="w-24" />
        </div>
        <p className="hidden py-2 bg-slate-500 text-white text-sm text-center shadow-xl my-2">
          Documentation
        </p>
      </div>
    </div>
  );
};

export default Sidebar;
